import { getAssetThreadUrl } from '#pplx/frontend/apps/ask/asset-utils/assetHelpers.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback } from 'react';
import { defineMessages } from 'react-intl';
const artifactsPinnedItemClickedEvent = EVENT_PAYLOAD;
export const pinnedArtifactMenuMessages = defineMessages({
    actions: {
        defaultMessage: 'Artifact actions',
        description: 'Accessible label for the button that opens a menu with artifact actions',
        id: 'd296a1ef7e',
    },
    openComputerSession: {
        defaultMessage: 'Open session',
        description: 'Context menu label to navigate to the computer task that produced an artifact (owner only)',
        id: 'ef966f3532',
    },
    openSearchSession: {
        defaultMessage: 'Open session',
        description: 'Context menu label to navigate to the thread that produced an artifact (owner only)',
        id: 'e1f32064ad',
    },
});
const UNAVAILABLE = { kind: 'unavailable' };
export function useSidebarPinnedArtifactInteractionsFactory(openArtifact) {
    const { track } = useInstrumentation();
    const router = useRouter();
    return useCallback(({ asset, title, position, placement }) => {
        const isInPopover = placement === 'collapsedPopover';
        return {
            open: (threadLinkTrack) => {
                track(artifactsPinnedItemClickedEvent({
                    name: 'artifacts_pinned_item_clicked',
                    data: {
                        artifact_id: asset.asset_id,
                        position,
                        source: isInPopover ? 'sidebar_hover_flyout' : 'sidebar_expanded',
                        is_in_popover: isInPopover,
                    },
                }));
                openArtifact(asset, threadLinkTrack ? { displayName: title, threadLinkTrack } : { displayName: title });
            },
            // Only owners can reach the session that produced the artifact.
            openSession: asset.viewer_relationship === 'OWNER' && asset.entry_uuid
                ? {
                    kind: 'available',
                    threadType: asset.source === 'asi' ? 'computer' : 'search',
                    entryUUID: asset.entry_uuid,
                    onSelect: () => router.push(getAssetThreadUrl(asset)),
                }
                : UNAVAILABLE,
        };
    }, [openArtifact, router, track]);
}
//# sourceMappingURL=useSidebarPinnedArtifactInteractions.js.map